import gql from 'graphql-tag'

export const GET_BRAND_PROFILE = gql`
  query getBrandProfile($brandUuid: ID!) {
    getBrandProfile(brandUuid: $brandUuid) {
      uuid
      subscriptionLevel
      permittedFeatures
      videoProjectsCount
      usersCount
      tradingName
      website
      address
      mainPhone
      seoTitle
      seoDescription
      seoKeywords
      facebookPage
      twitterName
      linkedinPage
      youtubeName
      functions
      coolness
      happiness
      history
      size
      department
      subbrandId
      billingAddressCountry
      billingAddressCity
      billingAddressRegion
      billingAddressLine1
      billingAddressLine2
      billingAddressLine3
      billingAddressPostCode
      billingAddressType
      billingName
      payCycle
      payCycleData {
        weekly
        monthly
        endOfMonth
        fromIssueDate
      }
      subbrands {
        id
        name
        state
      }
      division {
        id
        name
        state
      }
      children {
        uuid
        tradingName
        subbrandType
        city {
          name
          uuid
          country {
            name
            uuid
          }
        }
        avatar {
          cloudinaryId
          cloudinaryType
        }
        parent {
          uuid
        }
      }
      divisions {
        id
        name
        state
      }
      regions {
        name
      }
      ultimateParent {
        uuid
        tradingName
        divisions {
          id
          name
          state
        }
        subbrands {
          id
          name
          state
        }
      }
      parent {
        uuid
        tradingName
        divisions {
          id
          name
          state
        }
        subbrands {
          id
          name
          state
        }
      }
      industries {
        name
        uuid
      }
      city {
        name
        uuid
        subdivision1Name
        country {
          name
          uuid
        }
      }
      country {
        name
        uuid
        cities {
          name
          uuid
          subdivision1Code
          subdivision1Name
        }
      }
      avatar {
        cloudinaryId
        cloudinaryType
      }
      preferredCreators {
        uuid
        name
        avatar {
          cloudinaryId
          cloudinaryType
        }
        location {
          city
          country
          displayName
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/GetBrandProfileV2.tsx